module.exports = __webpack_public_path__ + "static/media/globe.d462ec3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globe.png
// module id = 179
// module chunks = 0